import { Rol } from '../Model/Rol';
export class RolesService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async findRoles() {
        const response = await this.apiService.get('roles');
        if (!response.ok) {
            throw new Error(`Error al obtener los roles.`);
        }
        const content = await response.json();
        return content.map(rol => new Rol(rol));
    }
    async isRol(rolId) {
        const response = await this.apiService.get('is_rol/' + rolId);
        if (!response.ok) {
            throw new Error(`Error al obtener el rol.`);
        }
        const content = await response.json();
        if (content) {
            return true;
        }
        return false;
    }
}
